import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

const TAG_COLORS = ['primary', 'secondary', 'dark', 'success', 'info'] as const;
type TagColor = (typeof TAG_COLORS)[number];

@Component({
  selector: 'nk-tag',
  imports: [RouterLink],
  templateUrl: './tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// Tags are inspired by material design chips: https://material-ui.com/demos/chips/
export class TagComponent {
  // Inputs
  public label = input.required<string>();
  public labelLink = input<string>('');
  public andClass = input<string>('');
  public actionIconClass = input<string>('');
  public labelRouterLink = input<string>('');
  public color = input<TagColor>();
  public actionIcon = input<string>('');
  public actionLink = input<string>('');
  public icon = input<string>('');
  public actionRouterLink = input<string>('');

  // Outputs
  public actionClick = output<string>();

  // Computed properties
  public hasLabelLink = computed(() => !!this.labelLink() || !!this.labelRouterLink());
  public hasActionIcon = computed(() => !!this.actionIcon());
  public hasIcon = computed(() => !!this.icon());
  public colorClass = computed(() => (this.color() ? `tag-${this.color()}` : ''));

  public actionOnClick(): void {
    if ((this.actionLink() && this.actionClick) || (this.actionClick && this.actionRouterLink())) {
      console.warn('You are passing both an actionLink and a actionOnClick. Use one in the tag');
    }

    if (this.actionClick) {
      this.actionClick.emit(this.label());
    } else if (this.actionRouterLink()) {
      window.location.href = this.actionLink();
    } else if (this.actionLink()) {
      window.location.href = this.actionLink();
    }
  }
}
